








































import { EventInfoData } from "@share/program/types/EventInfoData";
import { Component, Prop, Vue } from "vue-property-decorator";
import {Element} from "@api/models/Element";
import Countdown from "@share/common/countdown/session-countdown/SessionCountdown.vue";
import PartnersList from "@share/common/partners-list/PartnersList.vue";

import { getImageUrl } from "@common/ImageUrlHelper";
import { DateTime } from "luxon";
import { ProgramDataHelper } from "@share/program/helpers/ProgramDataHelper";
import { detectMob } from "@common/mobileHelper";
import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";

@Component({
  name: "CommingSoon",
  components: { Countdown, PartnersList },
})
export default class CommingSoon extends Vue {

  @Prop({ required: true }) eventInfoData: EventInfoData;
  @Prop({ default: false }) finished: boolean;
  @Prop({ default: "session" }) agendaType: string;
  @Prop({ default: false }) hasNext: boolean;
  @Prop({ default: false }) showBackButton: boolean;

  finishDate: DateTime | null = null;

  mounted() {
    if(this.finished) {

      const delaySeconds = Math.round(((Math.random() * 5000) + 5000) / 1000);

      this.finishDate = DateTime.local().plus({ seconds: delaySeconds });

    }
  }

  get backgroundImageUrl(): string {
    return getImageUrl(this.$route.params.backend, this.selectedEvent?.stageFileId, 1980);
  }

  get moreThenHour() {
    return this.eventInfoData.previewObject?.beginAt > DateTime.local().plus({ hour: 1 })
  }

  get selectedEvent(): Element | undefined {
    return this.$store.getters["events/selectedEvent"];
  }

  get partners() {
    const dataHelper = this.$store.getters['program/dataHelperByAgendaId'](this.eventInfoData.previewObject?.id) as ProgramDataHelper | undefined;
    const accentPartnerId = this.eventInfoData.previewObject?.partnerId;

    if(this.isAccentToOwnerPartner && accentPartnerId) {
      //возвращаем партнера которого может не быть в списке для баннера т.к. он "владеет" сессией
      return dataHelper?.exhibitions?.filter((partner) => partner.id === accentPartnerId);
    }
    else {
      return dataHelper?.exhibitions.filter((partner) => dataHelper.exhibitionIds.includes(partner.id)) || []
    }
  }

  get isMobile() {
    return detectMob()
  }

  get begin() {
    return this.eventInfoData?.previewObject?.beginAt
  }

  get isAccentToOwnerPartner() {
    return this.eventInfoData.previewObject?.type === SessionTypeEnum.roundtable
  }
}
